module.exports = __webpack_public_path__ + "media/images/area/feature/chugoku/related/vi/6-55b0750f996c13114cfc199d95a4207e.jpg";